import { api } from '../../../api/axios'
import type { Resultado, ResultadoFilters, CreateResultadoPayload, UpdateResultadoPayload, MapaResultadoItem } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const resultadosService = {
  list: (filters: ResultadoFilters = {}) =>
    api.get<ListResponse<Resultado>>('/resultados', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Resultado }>(`/resultados/${id}`).then(r => r.data.data),

  create: (data: CreateResultadoPayload) =>
    api.post<{ data: Resultado }>('/resultados', data).then(r => r.data.data),

  update: (id: number, data: UpdateResultadoPayload) =>
    api.put<{ data: Resultado }>(`/resultados/${id}`, data).then(r => r.data.data),

  getMapaByEtapa: (idetapa: number) =>
    api.get<{ data: MapaResultadoItem[] }>(`/etapas/${idetapa}/mapa-resultados`).then(r => r.data.data),

  reprocessar: (idmodalidade: number) =>
    api.post<{ data: { atualizados: number } }>(`/resultados/${idmodalidade}/reprocessar`).then(r => r.data.data),

  getTop: (limit = 20) =>
    api.get<{ data: Resultado[] }>('/resultados/top', { params: { limit } }).then(r => r.data.data),
}
